import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 30 }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay, ease: EASE }}
        className={className}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <span className="block overflow-hidden pb-1 md:pb-2">
        <motion.span
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay, ease: EASE }}
            className={`block ${className}`}
        >
            {children}
        </motion.span>
    </span>
);

export const FadeIn = ({ children, delay = 0, className = "" }) => (
    <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.9, delay, ease: EASE }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Chapter = ({ index, label, className = "" }) => (
    <Reveal y={16} className={className}>
        <p className="flex items-center gap-4 text-xs font-semibold uppercase tracking-[0.25em] text-slate-500">
            <span className="text-slate-400">{index}</span>
            <span className="inline-block h-px w-10 bg-slate-300" />
            {label}
        </p>
    </Reveal>
);
